import React, {useState, useRef, useEffect} from 'react';
//External
import {
    Button,
    Input,
    Spinner,
} from "reactstrap";
import cx from "classnames";
import requestApi from "../../services/requestApi.service";

const CratioFileUploader = props => {

    // Create a reference to the hidden file input element
    const hiddenFileInput = React.useRef(null);
    const mediaErrorRef = React.useRef(null);
    const [fileName, setFileName] = useState("No file selected");
    const [mediaError, setMediaError] = useState("");

    const isFormUploader = props.formUploader || false;
    // Programatically click the hidden file input element
    // when the Button component is clicked
    const handleClick = event => {
        hiddenFileInput.current.click();
    };

    // Call a function (passed as a prop from the parent component)
    // to handle the user-selected file
    const handleChange = event => {
        const fileUploaded = event.target.files[0];
        if(fileUploaded){
            let fileName = fileUploaded.name;
            if(!isFormUploader){
                setFileName(fileName);
                props.handleFile(event);
            }else{
                processFormFileUpload(fileUploaded);
            }
        }
    };

    const scrollToMediaerror = () => {
		if(mediaErrorRef != null && mediaErrorRef.current != null){
			mediaErrorRef.current.scrollIntoView({ behavior: "smooth" });
		}
	};

    const processFormFileUpload = async (file) => {
        let params = {
            "ENTITY": "processuploadfile",
            "OPERATION": "Uploading img",
            "imageupload": "1",
            "file" : file,
            "isOtherApiReq" : true,
            "fileparamname" : "importpngimage"
        }
        let response = await requestApi.processFileUpload(params);

        if(response.issuccess){
            setFileName(response.data);
            setMediaError("");
            props.attributes.onChange({}, {name: props.attributes['fieldName'], value: response.data}, props.attributes);
        } else {
            setMediaError(response.errormsg);
        }
    }

    let filesAccept = "";
    let btnLbl = "";
    let mediaUrl = "";

    if(isFormUploader){
        filesAccept = props.attributes.filesAccept;
        btnLbl = props.attributes.label;
        mediaUrl = props.attributes.value;
    }else{
        filesAccept = props.filesAccept;
        btnLbl = props.btnLbl;
        mediaUrl = props.mediaUrl;
    }

    let uploadedFilename = fileName;
    let uploadedFileType = fileName !== undefined && fileName !== null && fileName !== '' ? fileName.split('.') : '';
    if(mediaUrl !== "" && mediaUrl !== undefined) {
        uploadedFilename = mediaUrl.split('/').pop();
    }

    if(!isFormUploader){
        if(fileName === "No file selected" && mediaError === "" && props.errors['mediaUrl'] !== undefined && props.errors['mediaUrl'] !== ""){
            setMediaError(props.errors['mediaUrl']);
        }
    }

    if(uploadedFileType[0] === 'No file selected' && mediaUrl !== undefined){
        let uploadedFileType1 = mediaUrl.split('/').pop();
        if(uploadedFileType1.indexOf("?") > 0){
            uploadedFileType1 = uploadedFileType1.split("?")[0];
        }
        let uploadedFileType2 = uploadedFileType1.split('.').pop();
        let filename = uploadedFileType1.split('.'+uploadedFileType2);
        uploadedFileType[0] = filename[0];
        uploadedFileType[1] = uploadedFileType2;
 
     }
     if(mediaUrl === ''){
         uploadedFileType[0] = "No file selected";
         uploadedFileType[1] = undefined;
     }
    if(fileName !== "No file selected" && fileName !== "" && !isFormUploader){
        if(mediaError !== ""){
            setMediaError("");
        }
    }
    if(mediaError !== undefined && mediaError !== '' && !isFormUploader){
        scrollToMediaerror();
    }

    const btnRef = useRef(null);
    
    useEffect(() => {
        if (props.isError && btnRef.current) {
            btnRef.current.focus({ preventScroll: true });
        }
    }, [props.isError]);

    return (
        <>
            <div className={cx(``,{
                'is-invalid' : mediaError !== "",
                'dInlineFlex' : !isFormUploader
            })} ref={mediaErrorRef}>
                <div className={`dInlineFlex`}>
                    <Button 
                        innerRef={btnRef}
                        color={'light'} 
                        onClick={handleClick} 
                        className={cx('file-uploader-btn', { 'border-danger text-danger': props.isError })} 
                        disabled={props.isLoading}
                        style={props.isError ? { borderColor: '#dc3545', boxShadow: '0 0 0 0.2rem rgba(220, 53, 69, 0.25)' } : {}}
                    >
                        {props.isLoading ? <><Spinner size="sm" /> Uploading...</> : btnLbl}
                    </Button>
                    <div className={'p-2 temp-file-upload'}>
                        <span className='overlope-dot-125px'>{uploadedFileType[0] && uploadedFileType[0] !== '' ? uploadedFileType[0] : ''}</span>
                        <span>{uploadedFileType[1] !== undefined && uploadedFileType[0] !== '' ? ' . '+uploadedFileType[1] : ''}</span>
                    </div>
                </div>
            <input
                accept={filesAccept}
                type="file"
                ref={hiddenFileInput}
                onChange={handleChange}
                style={{display: 'none'}}
            />
            </div>
            <em className={`error invalid-feedback ${mediaError !== "" ? '' : 'hide'}`}>{mediaError}</em>
        </>
    );
}
export default CratioFileUploader;
